import {Button} from "component/button";
import {Text} from "component/text";
import React, {useState} from "react";
import "./style.scss";
import { Box } from "zmp-ui";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { deliveryInfoState, showModalErrorOrderState, totalAmountState } from "state";
import { formatMoney } from "component/display/price";
import { ModalConfirm } from "component/product/confirm-modal";
import { CART_ICONS } from "pages/cart/interfaces/icon";
import { useCartProduct } from "../../hooks/useCartProduct";
import styled from "styled-components";

export const ButtonOrder = () => {
  const [orderStatus, setOrderStatus] = useState("pending");
  const totalAmount = useRecoilValue(totalAmountState);

  const showModalErrorOrder = useRecoilValue(showModalErrorOrderState);
  const setDisplayModalErrorOrder = useSetRecoilState(showModalErrorOrderState)

  const { func } = useCartProduct();

  return (
    <FooterStyled>
      {orderStatus === "pending" ? (
        <>
          <div className="buttonOrder">
            <div className="buttonOrder__text">
              <Text fontSize={15} style={{ color: "#7C88A6" }}>
                Tổng cộng
              </Text>
              <Text fontSize={18} fontWeight={600}>
                {formatMoney(totalAmount)}₫
              </Text>
            </div>
            {!!showModalErrorOrder && <ModalConfirm
                     {...{
                        icon: CART_ICONS.confirmWarning,
                        title: "Đặt hàng không thành công",
                        description: (
                           <>
                              <p>Đặt hàng không thành công</p>
                              <p>Vui lòng kiểm tra lại thông tin</p>
                           </>
                        ),
                        handleConfirm: () => {
                        },
                        onClose: () => setDisplayModalErrorOrder(false),
                        open: showModalErrorOrder,
                        confirm: false
                     }}
                  />}
            
            <div className="buttonOrder__button">
                  <Button onClick={func.updateOrder}>Đặt hàng</Button>
                </div>
          </div>
        </>
      ) : (
        <Box>
          <div className="buttonOrder">
            <div className="buttonOrder__textSuccess">
              <Text fontSize={15} style={{ color: "#7C88A6" }}>
                Tổng cộng
              </Text>
              <Text fontSize={18} fontWeight={600}>
                {formatMoney(totalAmount)}₫
              </Text>
            </div>
          </div>
        </Box>
      )}
    </FooterStyled>
  );
};
const FooterStyled = styled.div`
  box-shadow: 0 -8px 12px 0 rgba(0, 0, 0, 0.03);
  display: flex;
  flex-direction: column;
  position: -webkit-sticky;
  position: sticky;
  background: #fff;
  bottom: 0;
  transition: opacity 0.3s ease-out, -webkit-transform 0.3s ease-out;
  transition: opacity 0.3s ease-out, transform 0.3s ease-out;
  transition: opacity 0.3s ease-out, transform 0.3s ease-out,
    -webkit-transform 0.3s ease-out;
  width: 100%;
  z-index: 19;
  margin-bottom: 0px;
`;
